import axios from "axios";
import 'react-dotenv';
//const BASE_URL = 'https://api.garmenzo.com/api/v1';

const axiosPrivate = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
     headers: { 'Content-Type': 'application/json' },
});

axiosPrivate.interceptors.request.use(
    config => {
        const token = localStorage.getItem("token") || '';

        //console.log('process.env.REACT_APP_API_URL', process.env.REACT_APP_API_URL);
        //console.log('Token from localStorage:', token ? 'Token exists' : 'No token found');
        
        if (token && !config.headers['Authorization']) {
            config.headers['Authorization'] = `Bearer ${token}`;
            //console.log('Authorization header added:', config.headers['Authorization']);
        } else if (!token) {
            console.warn('No token available for authorization');
        } else {
            //console.log('Authorization header already exists:', config.headers['Authorization']);
        }
        
        return config;
    }, (error) => Promise.reject(error)
);

axiosPrivate.interceptors.response.use(
    (response) => response?.data || response,
    async (error) => {
        const originalRequest = error.config;

        // If the error status is 401 and there is no originalRequest._retry flag,
        // it means the token has expired and we need to refresh it
        if ((error.response.status === 401) && !originalRequest._retry) {
            originalRequest._retry = true;
            //window.location.href = '/login';

        }
        if (error.response.status === 500) {
            //return Promise.reject('Some error occured while processing the request. Please try again.');
            return Promise.reject(error);
            //return error.response?.data || error.response;
        }
  
        return Promise.reject(error);
    }
);

export default axiosPrivate;